// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_jb-1";
export var rowFirst = "_jb-3";
export var rowLast = "_jb-5";
export var rowMiddle = "_jb-4";
export var ticketListScroll = "_jb-2";
export var ticketStack = "_jb-0";